<div tds-tile variant="auto" class="analyst-section">
  <h2 class="no-margin">{{ source().name }}</h2>
  <tds-segmented-control [(selectedIndex)]="selectedTab">
    <button tds-segmented-control-option>Active analysts</button>
    <button tds-segmented-control-option>Former analysts</button>
  </tds-segmented-control>
  @if (selectedTab() === 0) {
    <div class="analyst-toolbar">
      <button tds-button variant="primary" (click)="openCreate()">Add</button>
    </div>
    <table class="analyst-table">
      <thead>
        <tr>
          <th>Full name</th>
          <th>Email</th>
          <th>Zones</th>
          <th>Start date</th>
          <th>Added by</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (analyst of activeAnalysts(); track analyst.id) {
          <tr>
            <td>{{ fullName(analyst) }}</td>
            <td>{{ analyst.userEmail }}</td>
            <td>{{ zonesLabel(analyst) }}</td>
            <td>{{ formatDate(analyst.startDate) }}</td>
            <td>{{ analyst.addedByEmail }}</td>
            <td>
              <button tds-button variant="secondary-danger" (click)="removeAnalyst(analyst)">Remove</button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="6">No active analyst.</td>
          </tr>
        }
      </tbody>
    </table>
  }
  @if (selectedTab() === 1) {
    <table class="analyst-table">
      <thead>
        <tr>
          <th>Full name</th>
          <th>Email</th>
          <th>Zones</th>
          <th>Start date</th>
          <th>Added by</th>
          <th>End date</th>
          <th>Removed by</th>
        </tr>
      </thead>
      <tbody>
        @for (analyst of formerAnalysts(); track analyst.id) {
          <tr>
            <td>{{ fullName(analyst) }}</td>
            <td>{{ analyst.userEmail }}</td>
            <td>{{ zonesLabel(analyst) }}</td>
            <td>{{ formatDate(analyst.startDate) }}</td>
            <td>{{ analyst.addedByEmail }}</td>
            <td>{{ analyst.endDate ? formatDate(analyst.endDate) : '' }}</td>
            <td>{{ analyst.removedByEmail }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="7">No former analyst.</td>
          </tr>
        }
      </tbody>
    </table>
  }
</div>
